import { render } from "./FinishBlock.vue?vue&type=template&id=473acd78&scoped=true"
import script from "./FinishBlock.vue?vue&type=script&lang=js"
export * from "./FinishBlock.vue?vue&type=script&lang=js"

import "./FinishBlock.vue?vue&type=style&index=0&id=473acd78&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473acd78"]])

export default __exports__